<template>
  <div>
    <br>
    <Incentifyer-Accounts-Card/>
  </div>
</template>

<script>
export default {
  
}
</script>

<style>

</style>